const EpgConstants = {
    // Longitud de cada intervalo de tiempo de la línea horizontal de tiempo,
    // en segundos osea de 30 minutos
    TIMELINE_CELL_SIZE_MS: 30 * 60 * 1000, // 30 minutos en milisegundos
    // Número de intervalos 
    TOTAL_TIMELINE_INTERVALS: 3,

    TOTAL_ROWS_CHANNEL_GRID: 5,

    GRIDEVENT_LEFT_NAVIGATION: 'GRID_NAV_LEFT',
    GRIDEVENT_RIGHT_NAVIGATION: 'GRID_NAV_RIGHT',

    // Numérico, en pixeles
    VERTICAL_SPACE_BETWEEN_ROWS: 1,
    HORIZONTAL_SPACE_BETWEEN_ITEMS: 1,
    VERTICAL_ROW_HEIGHT: 76,
    ROW_WIDTH: 1128,

    ITEM_IMAGE_WIDTH: 127,
    ITEM_TEXT_MIN_REQUIRED_WIDTH: 20,
    ITEM_HORIZONTAL_SPACE_BETWEEN_TEXT_AND_IMAGE: 5,

    OPACITY_GRID: 0.2,
    OPACITY_CHANNEL: 0.3,
    WITHOUT_OPACITY: 1.0,
    TIMEOUT_RESUME: 1000,

    // Refresh cada minuto
    INTERVAL_GRID_UPDATE_MS: 60 * 1000,
    ACTIONS_LOADING : {
        OPACITY: 'OPACITY',
        NONE: 'NONE'
    },
    YESTERDAY_LABEL: 'YESTERDAY',
    TODAY_LABEL: 'TODAY',
    TOMORROW_LABEL: 'TOMORROW',
    FAV_ID_ITEM: 'aaf_favorites_channels_fullEpg',
    FAV_CODE_ITEM: 'aaf_favorites_code',
    FROM_FULL_EPG: 'FULL_EPG'

};

export default EpgConstants;


// WEBPACK FOOTER //
// ./src/AAF/Nepg/EpgConstants.js